/**
 * stock & media: image uploads for product/category forms.
 *
 * A standalone file rather than an addition to `resources.ts` — that file
 * belongs to another agent's parallel fix in this iteration, and the
 * instruction for this package is to touch it only by appending new exports
 * at the very end, not to grow existing objects like `productsApi`. Kept
 * fully separate so there is nothing here for that other edit to conflict
 * with.
 */

import { api } from '../lib/apiClient.js';

export interface MediaUploadResponse {
  url: string;
  filename: string;
  contentType: string;
  sizeBytes: number;
}

export const mediaApi = {
  /** POST /api/v1/media — admin-only multipart upload. See routes/media.ts on the server for the exact validation (jpeg/png/webp sniffed from bytes, ~2 MB cap). */
  upload: (file: File | Blob): Promise<MediaUploadResponse> => {
    const form = new FormData();
    form.set('file', file);
    return api.postForm<MediaUploadResponse>('/media', form);
  },
};
